<script setup lang="ts">
  import CountrySelectQC from '@qicgroupdoha/qic-connect-ds/components/CountrySelectQC'
  import { useI18n } from 'vue-i18n'
  import type { CountryWithDetailsType } from '@/shared/types/other.types'

  interface Props {
    modelValue: CountryWithDetailsType | undefined
    countries: CountryWithDetailsType[]
    errors?: string[]
    isValid: boolean
    disabled: boolean
    filterFunction: (s: string) => CountryWithDetailsType[]
    label: string
  }

  const { locale } = useI18n()
  defineProps<Props>()
  defineEmits<{ (e: 'update:modelValue', value: CountryWithDetailsType): void }>()
</script>

<template>
  <CountrySelectQC
    :model-value="modelValue"
    with-input
    :label="label"
    :select-props="{
      errors,
      disabled,
      isValid,
      hideArrowIcon: isValid,
      name: 'nationality',
      filterFunction,
      locale,
    }"
    :countries="countries"
    is-filterable
    data-test="nationality-select"
    @update:model-value="$emit('update:modelValue', $event)"
  />
</template>
